import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, abs, errMsg, TYPE_LABELS } from "../lib/api";
import { PageHeader, Loading } from "../components/PageHeader";
import { MediaStream } from "../components/DigitalDelivery";

function LibraryItem({ it }) {
  const [busy, setBusy] = useState(false);
  const p = it.product;
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/library/${p.id}/download-link`);
      window.location.href = abs(data.download_url);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="wb-card p-6 fade-up" data-testid={`library-item-${p.slug}`}>
      <div className="flex gap-5">
        <div className="art-frame h-24 w-24 shrink-0"><img src={abs(p.image_urls?.[0])} alt="" className="h-full w-full object-cover" /></div>
        <div className="flex-1">
          <div className="eyebrow">{TYPE_LABELS[p.type]}</div>
          <Link to={`/product/${p.slug}`} className="mt-1 block font-display text-2xl hover:text-wb-gold transition-colors">{p.title}</Link>
          <div className="mt-1 font-mono text-xs muted">Order {it.order_number}</div>
        </div>
      </div>
      {it.stream_url && <div className="mt-6"><MediaStream item={{ type: p.type, stream_url: it.stream_url }} testid={`library-stream-${p.slug}`} /></div>}
      <button onClick={download} disabled={busy} className="btn-ghost mt-6 w-full" data-testid={`library-download-${p.slug}`}>
        <Download size={14} /> {busy ? "Preparing…" : "Download file"}
      </button>
    </div>
  );
}

export default function Library() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/library").then((r) => setItems(r.data)).catch((e) => { setItems([]); toast.error(errMsg(e)); });
  }, []);
  return (
    <div data-testid="library-page">
      <PageHeader eyebrow="My Library" title="Your collection">Stream your films and soundscapes, and download your digital works any time.</PageHeader>
      <div className="wb-container">
        {!items ? <Loading /> : items.length === 0 ? (
          <div data-testid="library-empty"><p className="muted">No digital works yet.</p><Link to="/shop?type=digital_art" className="btn-gold mt-8">Browse digital works</Link></div>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3" data-testid="library-grid">
            {items.map((it) => <LibraryItem key={it.product.id} it={it} />)}
          </div>
        )}
      </div>
    </div>
  );
}
